import { useState } from 'react';
import { useUser } from '../../../context/UserContext';
import { GetChangeRequestsByNPN } from '../../../api/MyIMO';
import { useQuery } from '@tanstack/react-query';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import NewChangeRequestModal from './modal/NewChangeRequestModal';
import { Typography, Box, Stack, Button, Alert } from '@mui/material';
import ChangeRequestDataGrid from './datagrid/ChangeRequestDataGrid';

const ChangeRequests = ({ producerID }) => {
  const user = useUser();
  const [showNewRequestModal, setShowNewRequestModal] = useState(false);

  const getChangeRequestsByNPN = useQuery({
    queryKey: ['getChangeRequestsByNPN'],
    queryFn: () => GetChangeRequestsByNPN()(),
    refetchOnWindowFocus: true,
  });

  const toggleModal = () => {
    setShowNewRequestModal((prev) => !prev);
  };

  return (
    <Box sx={{ padding: '1rem' }}>
      {getChangeRequestsByNPN.isError && (
        <Box padding={'1rem 0'}>
          <Alert sx={{ width: 'fit-content' }} severity="warning">
            Something went wrong
          </Alert>
        </Box>
      )}
      <Stack
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        direction={{ xs: 'column', md: 'row' }}
      >
        <Typography component={'h3'} sx={{ padding: '1rem 0' }} variant="h6">
          Change Requests
        </Typography>
        <Stack
          direction="row"
          gap={2}
          width={{ xs: '100%', md: 'unset' }}
          justifyContent={{ xs: 'flex-end', md: 'unset' }}
          padding={{ xs: '.5rem 0', md: 'unset' }}
        >
          <Button
            onClick={toggleModal}
            sx={{ height: 'fit-content', padding: '.5rem .875rem' }}
            variant="contained"
          >
            New Request
          </Button>
        </Stack>
      </Stack>
      {getChangeRequestsByNPN.isLoading ? (
        <LoadingIndicator />
      ) : (
        <ChangeRequestDataGrid
          isLoading={getChangeRequestsByNPN.isLoading}
          data={getChangeRequestsByNPN.data}
        />
      )}
      <NewChangeRequestModal
        producerID={producerID}
        showModal={showNewRequestModal}
        toggleModal={toggleModal}
        refetchRequests={getChangeRequestsByNPN.refetch}
        IMOSubmission={user.userType === 'IMO' || user.userType === 'SUB-IMO'}
      />
    </Box>
  );
};

export default ChangeRequests;
